import { Observable } from 'rxjs/Observable';
import { Input, HostListener, OnInit, OnChanges, SimpleChanges, Output, Component, ElementRef, EventEmitter } from '@angular/core';

@Component({
  selector: 'dropdown-time',
  templateUrl: './dropdown-time.component.html',
  styleUrls: ['./dropdown-time.component.scss'],
  host: { '(document:click)': 'onClick($event)' },
})
export class DropdownTimeComponent implements OnInit, OnChanges {

  // Inputs variables
  @Input() items: any[];
  @Input() image: string | null = null;
  @Input() selected: any | null = null;

  // Output variables
  @Output() onItemSelect: EventEmitter<any> = new EventEmitter<any>();

  // Suscriptions
  private selectedWatch$: any;

  // Selected item
  public itemSelected: string | null;
  public itemImageSelected: string | null;
  // Dropdown open status
  public dropdownOpened: boolean = false;

  // Constructor
  constructor(private _eref: ElementRef) { }

  // On component init
  ngOnInit() {
    this.itemSelected = (this.items && this.items.length > 0) ? this.items[0].text : null;
    this.itemImageSelected = (this.items && this.items.length > 0) ? this.items[0].image : null;
    if (this.selected) this.findSelected();
  }

  // On component do check
  ngOnChanges(changes: SimpleChanges) {
    if (changes.selected && changes.selected.previousValue && changes.selected.currentValue !== changes.selected.previousValue)
      this.findSelected();
  }

  // Fill selected
  private findSelected(): void {
    for (let i = 0; i < this.items.length; i++){
      if (this.items[i].text === this.selected){
        this.itemSelected = (this.items && this.items.length > 0) ? this.items[i].text : null;
        this.itemImageSelected = (this.items && this.items.length > 0 && this.items[i].image) ? this.items[i].image : null;
        break;
      }
    }
  }

  // On element click
  public onClick(event): void {
    if (!this._eref.nativeElement.children[0].children[0].contains(event.target) && this.dropdownOpened) this.dropdownOpened = false;
  }

  // Selecting an item
  public itemSelect(item, disabled): void {
    if (!disabled) {
      this.itemSelected = item.text;
      this.itemImageSelected = item.image;
      this.onItemSelect.emit(item);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/dropdown-time/dropdown-time.component.ts